import { defaultMessages } from '../languageData';
import type { IntlShape } from 'react-intl';
import { getSupportedLocaleForTenant } from '../../configuration/lang/lang';
import type { LanguageDropdownItem, SupportedLocales } from '../../configuration/types';

const LOCALE_ID_PREFIX = 'intl-msg:registration.language.locale.';

const sortLocales = (locales: SupportedLocales, messagesOfLocale: { [key: string]: string }) => {
    return locales
        .map((locale: string) => {
            return {
                locale: locale,
                displayName: messagesOfLocale[`${LOCALE_ID_PREFIX}${locale}`],
            };
        })
        .sort((a, b) => {
            const displayNameA = a.displayName || '';
            const displayNameB = b.displayName || '';

            /* eslint-disable no-console */
            console.assert(displayNameA.length > 0, `translation missing for key: ${LOCALE_ID_PREFIX}${a.locale}`);
            console.assert(displayNameB.length > 0, `translation missing for key: ${LOCALE_ID_PREFIX}${b.locale}`);

            return displayNameA.toLocaleLowerCase().localeCompare(displayNameB.toLocaleLowerCase());
        })
        .map(item => item.locale);
};

export const getLanguageDropDownItems = (tenant: string | undefined, selectedLanguage: string, intl: IntlShape) => {
    const options: LanguageDropdownItem[] = [];
    const locales = tenant ? [...getSupportedLocaleForTenant(tenant)] : [];
    const sortedLocales = sortLocales(locales, defaultMessages);
    sortedLocales.forEach((locale: string) => {
        options.push({
            id: locale,
            label: intl.formatMessage({ id: `intl-msg:registration.language.locale.${locale}` }),
            selected: selectedLanguage === locale,
        });
    });
    return options;
};
